import styled from "styled-components";
import css from "@styled-system/css";
import { variant, layout, typography, space } from "styled-system";

import { ButtonProps, LinkButtonProps } from "./button.type";
import variants from "./variants";

const Button = styled.button<ButtonProps | LinkButtonProps>`
  height: 48px;
  cursor: pointer;
  width: auto;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-sizing: border-box;
  &[disabled] {
    opacity: 0.3;
    cursor: default;
  }
  &:focus {
    outline: none;
  }
  ${(props) => {
    const themedVariants = variants(props.theme);
    return variant({ variants: themedVariants });
  }}

  ${css({
    fontFamily: "normal",
    fontSize: "body",
    fontWeight: "semiBold",
    borderRadius: 2,
  })}
  ${layout}
  ${typography}
  ${space}
  ${(props) => props.css}
`;

export default Button;
